export default __webpack_public_path__ + "static/media/Rubik-Medium.2263cf4b.ttf";